/* ============================================================
   Auto page translation by visitor location/language.
   HONEST LIMITATION: this is Google's website translation
   widget (machine translation), not professionally translated
   content. See earlier note for full context.

   FIXED: now waits until the page has fully loaded (window
   'load' event, not DOMContentLoaded) plus an extra delay,
   so this never competes with or blocks the initial render of
   the actual page content. Runs completely independently of
   the currency script — no shared observers, no interaction
   between the two.
   ============================================================ */
(function () {
  'use strict';

  var CACHE_KEY = 'tg_lang_v1';

  var COUNTRY_LANG = {
    FR: 'fr', DE: 'de', ES: 'es', IT: 'it', JP: 'ja',
    CN: 'zh-CN', KR: 'ko', BR: 'pt', PT: 'pt', RU: 'ru',
    SA: 'ar', AE: 'ar', NL: 'nl', SE: 'sv', TR: 'tr',
    MX: 'es', TH: 'th', VN: 'vi', ID: 'id'
  };

  function getCachedLang() {
    try { return sessionStorage.getItem(CACHE_KEY); } catch (e) { return null; }
  }

  function setCachedLang(lang) {
    try { sessionStorage.setItem(CACHE_KEY, lang); } catch (e) {}
  }

  function loadGoogleTranslate(targetLang) {
    if (document.getElementById('tg-google-translate-script')) return;

    window.googleTranslateElementInit = function () {
      new google.translate.TranslateElement(
        { pageLanguage: 'en', autoDisplay: false },
        'tg-translate-mount'
      );
      setTimeout(function () {
        var select = document.querySelector('.goog-te-combo');
        if (select) {
          select.value = targetLang;
          select.dispatchEvent(new Event('change'));
        }
      }, 800);
    };

    var mount = document.createElement('div');
    mount.id = 'tg-translate-mount';
    mount.style.cssText = 'position:fixed;bottom:8px;right:8px;z-index:9999;opacity:0.85;';
    document.body.appendChild(mount);

    var script = document.createElement('script');
    script.id = 'tg-google-translate-script';
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);
  }

  function detectAndTranslate() {
    var cached = getCachedLang();
    if (cached) {
      if (cached !== 'en') loadGoogleTranslate(cached);
      return;
    }

    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.success || !data.country_code) return;
        var lang = COUNTRY_LANG[data.country_code];
        if (!lang) {
          setCachedLang('en');
          return;
        }
        setCachedLang(lang);
        loadGoogleTranslate(lang);
      })
      .catch(function () {});
  }

  function start() {
    setTimeout(detectAndTranslate, 1500);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
